<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn.mx-2(v-if="type == 'create'" style="bottom:50px" fab dark right fixed v-on="on")
        v-icon(dark) mdi-plus
      v-btn.mx-2(v-else-if="type == 'createsimple'" fab dark small v-on="on")
        v-icon(dark) mdi-plus
      v-btn(v-else-if="type == 'edit'" color="primary" v-on="on" text)
        v-icon(dark) mdi-pencil
      v-btn(v-else v-on="on" color="primary" text) {{ button }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        slot(:close="closeDialog", :opened="dialog")
          //- Ejemplo de uso
          //- BaseTwoWayDialog(v-slot="{close}")
          //-   test(@eventoDeTest="close")
          //- BaseTwoWayDialog(v-slot="{close, opened}")
          //-   test(@eventoDeTest="close" :propDeTest="opened")
</template>

<script>
  export default {
    name: "BaseDialog",
    props:{
      title: {
        type: String,
        default: 'Titulo'
      },
      button: {
        type: String,
        default: 'Detalle'
      },
      type: {
        type: String,
        default: ''
      }
    },
    data:() => ({
      dialog: false,
    }),
    methods:{
      closeDialog(){
        this.dialog = false;
      },
    }
  }
</script>

<style lang="sass">
</style>